import React from 'react'
import { twMerge } from 'tailwind-merge'

import CoversContainer, {
  CoversContainerExpanded,
} from '../../components/quotation/pricing/CoversContainer'

import { OnboardingTitle } from './OnboardingTitle'
import { PricingASDCoversOptions } from './PricingASDCoversOptions'

type Props = React.PropsWithChildren & {
  className?: string
  extended?: boolean
  displayOnlyCover?: boolean
}

export const PricingASDCoversSection = React.forwardRef<HTMLElement, Props>(
  ({ className, extended, displayOnlyCover }, ref) => {
    const Container = extended ? CoversContainerExpanded : CoversContainer

    return (
      <section className={twMerge('w-full', className)} id="covers" ref={ref}>
        <Container deductible={0}>
          {displayOnlyCover && <OnboardingTitle.H3>Votre couverture</OnboardingTitle.H3>}

          <PricingASDCoversOptions displayOnlyCover={displayOnlyCover} />
        </Container>
      </section>
    )
  }
)
